import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Button = styled.button`
  padding: 12px 22px;
  font-size: ${fontSize.s};
  color: ${colors.backgroundPrimary};
  border: 1px solid ${colors.black};
  background-color: ${colors.black};
  cursor: pointer;
  &:hover {
    background-color: #1b1b1be3;
    border: 1px solid #1b1b1be3;
    transition-duration: 0.2s;
    color: ${colors.backgroundPrimary};
  }
  &:disabled {
    background-color: ${colors.backgroundPrimary};
    border: 1px solid ${colors.border};
    color: ${colors.border};
  }
`;
function FilledButton({ text, onClick, style, disabled = false }) {
  return (
    <Button
      disabled={disabled && disabled}
      style={style}
      onClick={() => {
        onClick && onClick();
      }}
    >
      {text}
    </Button>
  );
}

export default FilledButton;
